import {
  CREATE_RELAY_LOAD_CONTRACT,
  DELETE_RELAY_LOAD_CONTRACT,
  EDIT_RELAY_LOAD_CONTRACT,
  RECEIVE_RELAY_LOAD_CONTRACTS,
  REQUEST_RELAY_LOAD_CONTRACT,
  REQUEST_RELAY_LOAD_CONTRACT_FOR_RELAY_LOAD,
  REQUEST_RELAY_LOAD_CONTRACT_FOR_SITE,
} from '@sophocles/entities/RelayLoadContract/relayLoadContractActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RELAY_LOAD_CONTRACTS: // Read
      return state.merge(action.relayLoadContracts);
    case DELETE_RELAY_LOAD_CONTRACT: // Delete
      return state.delete(action.relayLoadContract.toString());
    case EDIT_RELAY_LOAD_CONTRACT: // Update
    case CREATE_RELAY_LOAD_CONTRACT: // Create
    case REQUEST_RELAY_LOAD_CONTRACT:
    case REQUEST_RELAY_LOAD_CONTRACT_FOR_SITE:
    case REQUEST_RELAY_LOAD_CONTRACT_FOR_RELAY_LOAD:
    default:
      return state;
  }
}

export function relayLoadContractReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_RELAY_LOAD_CONTRACT:
    case DELETE_RELAY_LOAD_CONTRACT:
    case RECEIVE_RELAY_LOAD_CONTRACTS:
    case EDIT_RELAY_LOAD_CONTRACT:
    case REQUEST_RELAY_LOAD_CONTRACT:
    case REQUEST_RELAY_LOAD_CONTRACT_FOR_SITE:
    case REQUEST_RELAY_LOAD_CONTRACT_FOR_RELAY_LOAD:
      return getState(state, action);
    default:
      return state;
  }
}
